export const _monitor = 'monitor';
export const _string = 'string';
export const _number = 'number';
export const _boolean = 'boolean';
export const _enum = 'enum';

export const CTRL_MODE = 'T2';//控制模式
export const APP_VERSION = 'T4'; //软件版本

